import React, { FC, useState, useEffect } from 'react';
import './style.scss';

interface Props {
  currentPage?: number;
  totalCount: number;
  rowSize?: number;
  viewPageSize?: number;
  onChangePage: (num: number) => void;
}

const DefaultPaging: FC<Props> = ({
  currentPage = 1,
  totalCount,
  rowSize = 10,
  viewPageSize = 5,
  onChangePage,
}) => {
  const pageTotal = Math.ceil(totalCount / rowSize) || 0;
  const currentRowsize = Math.ceil(currentPage / viewPageSize) * viewPageSize + 1 || 1;
  const currentRowsizeArr = [];
  for (let idx = currentRowsize - viewPageSize; idx < currentRowsize; idx++) {
    if (idx <= pageTotal) currentRowsizeArr.push(idx);
  }
  const ppreClass = ['_item ', '_ppre', '_btn'];
  const preClass = ['_item', '_pre', '_btn'];
  const nnextClass = ['_item', '_nnext', '_btn'];
  const nextClass = ['_item', '_next', '_btn'];
  currentPage === 1 && ppreClass.push('_dim');
  currentPage === 1 && preClass.push('_dim');
  pageTotal === currentPage && nnextClass.push('_dim');
  pageTotal === currentPage && nextClass.push('_dim');

  const pageClick = (num: number, classStr: any, status: string) => {
    if (num - 1 === pageTotal) return false;
    const disabled = classStr.find((item: any) => item === '_dim');
    if (disabled) return false;
    if (num === 0) return false;
    onChangePage(num);
  };
  const pageNextClick = (num: number, classStr: any, status: string) => {
    const disabled = classStr.find((item: any) => item === '_dim');
    if (disabled) return false;

    let reNum = Math.floor((num - 1) / viewPageSize + 1) * viewPageSize + 1;
    if (reNum > pageTotal) reNum = pageTotal;
    onChangePage(reNum);
  };
  const pagePreClick = (num: number, classStr: any, status: string) => {
    const disabled = classStr.find((item: any) => item === '_dim');
    if (disabled) return false;
    let reNum = Math.floor((num - 1) / viewPageSize + 1) * viewPageSize - (viewPageSize - 1);
    if (reNum <= 0) reNum = 1;
    onChangePage(reNum);
  };

  return (
    <div className="_defalut_paging_div">
      <div className="_paging_div">
        <div className={ppreClass.join(' ')} onClick={() => pageClick(1, ppreClass, 'ppre')} />
        <div
          className={preClass.join(' ')}
          onClick={() => pagePreClick(currentPage - 1, preClass, 'pre')}
        />
        {currentRowsizeArr.map((num: number) => {
          const selected = currentPage === num ? '_sel' : '';
          return (
            <div
              className={['_item', '_num', selected].join(' ')}
              onClick={e => pageClick(num, [selected], 'this')}
              key={num}
            >
              {num}
            </div>
          );
        })}
        <div
          className={nextClass.join(' ')}
          onClick={() => pageNextClick(currentPage, nextClass, 'next')}
        />
        <div
          className={nnextClass.join(' ')}
          onClick={() => pageClick(pageTotal, nnextClass, 'nnext')}
        />
      </div>
    </div>
  );
};

export default DefaultPaging;
